import React from 'react'
import PropTypes from 'prop-types'
import EditForm from '../edit_form'
import PoolCover from 'components/pool_cover'
import CrowdFundingCoverImage from 'components/crowdfunding_cover_image'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

class EditDescription extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    campaignType: PropTypes.string,
  }

  render() {
    const showTitle = this.props.campaignType === CROWD_FUNDING
    const CoverComp =
      this.props.campaignType === CROWD_FUNDING
        ? CrowdFundingCoverImage
        : PoolCover

    return (
      <EditForm {...this.props}>
        <CoverComp
          fields={this.props.fields}
          showDoneButton={true}
          showTitle={showTitle}
        />
      </EditForm>
    )
  }
}

export default EditDescription
